import { useEffect } from "react";
import { useLang } from "./LangContext";
import { useSettings, branchChannelLink, channelLink, getFaqAnswers } from "./SettingsContext";

export const HomepageMetadata = () => {
  const { t, lang } = useLang();
  const { settings } = useSettings();

  useEffect(() => {
    document.title = t.seo.title;
    for (const selector of ['meta[name="description"]', 'meta[property="og:description"]', 'meta[name="twitter:description"]']) {
      document.querySelector(selector)?.setAttribute("content", t.seo.description);
    }
    for (const selector of ['meta[property="og:title"]', 'meta[name="twitter:title"]']) {
      document.querySelector(selector)?.setAttribute("content", t.seo.title);
    }
    document.querySelector('meta[property="og:locale"]')?.setAttribute("content", lang === "tr" ? "tr_TR" : "en_US");
    document.querySelector('meta[property="og:locale:alternate"]')?.setAttribute("content", lang === "tr" ? "en_US" : "tr_TR");
    const script = document.getElementById("site-structured-data");
    const graph = JSON.parse(script.textContent)["@graph"].filter((node) => node["@type"] !== "FAQPage");
    graph[0].description = t.seo.description;
    graph[1].description = t.hero.subtitle;
    graph[1].sameAs = ["instagram", "facebook"].map((channel) => channelLink(channel, settings?.contact)?.href).filter(Boolean);
    for (const branch of t.branches.items) {
      const node = graph.find((entry) => entry["@id"].endsWith(`#${branch.id}`));
      node.description = `${branch.name}. ${t.branches.lead}`;
      const phone = branchChannelLink(branch.id, "phone", settings?.contact);
      if (phone) node.telephone = phone.href.slice(4);
      else delete node.telephone;
      const whatsapp = branchChannelLink(branch.id, "whatsapp", settings?.contact);
      if (whatsapp) node.contactPoint = { "@type": "ContactPoint", contactType: "WhatsApp", url: whatsapp.href };
      else delete node.contactPoint;
      const price = settings?.prices?.[branch.id];
      if (price != null) node.makesOffer = {
        "@type": "Offer", itemOffered: { "@type": "Service", name: "PC Gaming" },
        priceSpecification: { "@type": "UnitPriceSpecification", price, priceCurrency: "TRY", unitCode: "HUR", unitText: t.pricing.hour },
      };
      else delete node.makesOffer;
    }
    const mainEntity = t.faq.items.flatMap((item) => {
      const answers = getFaqAnswers(item, settings, t, lang);
      return answers.length ? [{ "@type": "Question", name: item.q, acceptedAnswer: { "@type": "Answer", text: answers.join(" ") } }] : [];
    });
    graph.push({ "@type": "FAQPage", "@id": `${process.env.REACT_APP_BACKEND_URL.replace(/\/$/, "")}/#sss`, inLanguage: lang, mainEntity });
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
  }, [t, lang, settings]);

  return null;
};
